import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "block font-medium text-sm mb-1",
  for: ""
}
const _hoisted_2 = ["model-value", "placeholder", "type", "onInput"]
const _hoisted_3 = {
  key: 1,
  class: "text-sm text-red-600 mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vee_field = _resolveComponent("vee-field")!

  return (_openBlock(), _createBlock(_component_vee_field, {
    name: _ctx.name,
    rules: _ctx.rules
  }, {
    default: _withCtx(({ errorMessage, value, field }) => [
      _createElementVNode("div", _mergeProps({
        class: ["w-full text-field", { 'text-red-400': !!errorMessage }]
      }, _ctx.$attrs), [
        (_ctx.title != null)
          ? (_openBlock(), _createElementBlock("label", _hoisted_1, _toDisplayString(_ctx.title), 1))
          : _createCommentVNode("", true),
        _createElementVNode("input", _mergeProps({ "model-value": value }, field, {
          class: ["p-3 w-full border outline-none text-gray-900 rounded transition-colors duration-150 ease-in-out", [
          !!errorMessage
            ? 'border-red-400 focus:border-red-600'
            : 'focus:border-blue-400 border-gray-300'
        ]],
          placeholder: _ctx.placeholder,
          type: _ctx.type,
          onInput: ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))
        }), null, 16, _hoisted_2),
        (!!errorMessage && _ctx.hasErrorSlotPopulate == false)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorMessage), 1))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "error", { errorMessage: errorMessage })
      ], 16)
    ]),
    _: 3
  }, 8, ["name", "rules"]))
}